import PureLoadable from 'react-17-pure-loadable';

export default PureLoadable({
  loader: () => import('./CompanySpecificSkillLogo.jsx'),
  displayName: 'CompanySpecificSkillLogo',
});
